import { CreditCard, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const PaymentStep = ({ 
  uploadedFiles,
  totalPages,
  preferences,
  cost,
  onBack,
  onPay,
  onDemoPay,
  loading
}) => {
  // Build document name for display
  const documentName = uploadedFiles.length === 1 
    ? uploadedFiles[0].filename 
    : `${uploadedFiles.length} files`;

  return (
    <Card className="w-full max-w-md" data-testid="payment-card">
      <CardHeader>
        <CardTitle className="font-heading text-2xl">Confirm Order & Pay</CardTitle>
        <CardDescription>Pay ₹{cost} to start printing</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="bg-secondary rounded-lg p-6 space-y-3">
          <div className="flex justify-between">
            <span>Document(s):</span>
            <span className="font-medium text-right max-w-[200px] truncate">{documentName}</span>
          </div>
          <div className="flex justify-between">
            <span>Pages:</span>
            <span className="font-medium">{totalPages} × {preferences.copies} copies</span>
          </div>
          <div className="flex justify-between">
            <span>Paper Size:</span>
            <span className="font-medium">{preferences.paper_size}</span>
          </div>
          <div className="flex justify-between">
            <span>Mode:</span>
            <span className="font-medium">
              {preferences.color_mode === 'color' ? 'Color' : 'B&W'}
              {preferences.duplex && ' • Duplex'}
            </span>
          </div>
          <div className="border-t border-border pt-3 flex justify-between items-center">
            <span className="text-lg font-medium">Total:</span>
            <span className="text-3xl font-heading font-bold text-accent">₹{cost}</span>
          </div>
        </div>

        <div className="text-center pt-1 space-y-2">
          <div className="flex items-center justify-center gap-2 text-xs font-medium text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-800 rounded-md p-2">
            <span>🔒 Secure Online Payment via Cashfree Payment Gateway</span>
          </div>
          <p className="text-xs text-muted-foreground">
            Supports <span className="font-medium text-foreground">UPI, Credit/Debit Cards, NetBanking & Wallets</span>
          </p>
        </div>

        <div className="pt-2 flex flex-col gap-2">
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onBack}
              disabled={loading}
              data-testid="back-to-details-btn"
              className="flex-1"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <Button
              className="btn-primary flex-1"
              onClick={onPay}
              disabled={loading}
              data-testid="pay-now-btn"
            >
              <CreditCard className="w-4 h-4 mr-2" />
              {loading ? 'Processing...' : 'Confirm & Pay'}
            </Button>
          </div>

          {onDemoPay && (
            <button
              type="button"
              onClick={onDemoPay}
              disabled={loading}
              className="text-xs text-muted-foreground hover:text-foreground text-center underline pt-1 cursor-pointer"
            >
              Bypass Cashfree (Test Demo Payment)
            </button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentStep;
